var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsSemVer, IsString, IsUUID, MaxLength, MinLength, } from 'class-validator';
import { AddressFieldDto } from '../address-field.js';
import { ActivityPointSummaryFullSizeDto } from '../../activity-point/dtos/activity-point-summary.full-size.dto.js';
import { ActivityPointTrackingFullSizeDto } from '../../activity-point/dtos/activity-point-tracking.full-size.dto.js';
import { AnamnesisFullSizeDto } from '../../anamnesis/dtos/anamnesis.full-size.dto.js';
import { CallPatientFullSizeDto } from '../../calls/dto/call-patient.full-size.dto.js';
import { CallFullSizeDto } from '../../calls/dto/call.full-size.dto.js';
import { CustomFormAnswerFullSizeDto, CustomFormFullSizeDto } from '../../custom-form/index.js';
import { ExerciseProgramFullSizeDto } from '../../exercise-programs/dtos/exercise-program.full-size.dto.js';
import { ExerciseFavouriteFullSizeDto } from '../../exercise/dtos/exercise-favourite.full-site.dt.js';
import { ExerciseFullSizeDto } from '../../exercise/dtos/exercise.full-size.dto.js';
import { PatientvideoConsentDeclarationFullSizeDto } from '../../exercise/dtos/patientvideo-consent-declaration.full-size.dto.js';
import { FeatureRankingFullSizeDto } from '../../feature-ranking/index.js';
import { HubSpotQuestionAnswerFullSizeDto } from '../../hubspot-questions/index.js';
import { InvoiceFullSizeDto } from '../../invoice/dtos/invoice.full-size.dto.js';
import { NotificationFullSizeDto } from '../../notification/dto/notification.full-size.dto.js';
import { OfficeProductAssignmentFullSizeDto } from '../../office-products/dtos/office-product-assignment.full-size.dto.js';
import { OfficeLocationStub } from '../../offices/dto/office-location-stub.dto.js';
import { OfficeLocationFullSizeDto } from '../../offices/dto/office-location.full-size.dto.js';
import { OfficeFullSizeDto } from '../../offices/dto/office.full-size.dto.js';
import { ConnectedStripeCustomerPatientFullSizeDto } from '../../payment/dto/connected-stripe-customer-patient.full-size.dto.js';
import { PaymentFullSizeDto } from '../../payment/payment.full-size.dto.js';
import { PreventionCourseApprovalFullSizeDto } from '../../prevention-courses/index.js';
import { PreventionModuleTrackingFullSizeDto } from '../../prevention-courses/dtos/prevention-module-tracking.full-size.dto.js';
import { PreventionSectionTrackingFullSizeDto } from '../../prevention-courses/dtos/prevention-section-tracking.full-size.dto.js';
import { ReminderUserFullSizeDto } from '../../reminder/dto/reminder-user.full-size-dto.js';
import { Role } from '../../roles/index.js';
import { TrainingSessionFullSizeDto, UserTrainingSessionStatsFullSizeDto, } from '../../training-sessions/index.js';
import { AccessStatus } from '../enums/access-status.enum.js';
import { ApiKeyFullSizeDto } from './apikey.full-size.dto.js';
import { ConsentDeclarationFullSizeDto } from './consentDeclaration.full-size.dto.js';
import { FileUploadFullSizeDto } from './file-upload.full-size.dto.js';
import { PatientStatusDto } from './patient-status.dto.js';
import { UserDiagnosisFullSizeDto } from './user-diagnosis.full-size.dto.js';
import { UserIcd10FullSizeDto } from './user-icd10.full-size.dto.js';
import { ConsentDeclarerDto } from './user.response.dto.js';
import { UserSettingsFullSizeDto } from './user-settings.full-size.dto.js';
import { UserStatsFullSizeDto } from './user-stats.full-size.dto.js';
/**
 * @deprecated This DTO is too heavy to be used. Use `UserResponseDto` or `UserLiteDto` instead.
 */
export class UserFullSizeDto {
    id;
    keycloakId;
    createdAt;
    updatedAt;
    deletedAt;
    officeId;
    currentOfficeLocationId;
    email;
    /** Where the office sends this Person's mail — see `UserResponseDto.contactEmail`. */
    contactEmail;
    /** The email field as this viewer may see and change it — see `UserResponseDto.addressField`. */
    addressField;
    /** Who declared the consent in the patient's context — see `UserResponseDto.consentDeclaredBy`. */
    consentDeclaredBy;
    firstName;
    lastName;
    birthdate;
    mobilePhone;
    profileImage;
    notes;
    registeredAt;
    /**
     * The patient's login lifecycle (Zugangsstatus, TM-9118). Successor to the
     * dropped registrationMode/isOnboarded pair (TM-9181); drives the access badge.
     */
    accessStatus;
    street;
    zip;
    town;
    industry;
    website;
    krankenkasse;
    pkvInsurerName;
    pkvPolicyNumber;
    salutation;
    role;
    therapyArea;
    therapistId;
    agreedTermsConditions;
    dateAgreedTermsConditions;
    agreedTermsConditionsType;
    isArchived;
    countryCode;
    agreedConsentfile;
    customFormAnswers;
    callsAsPatient;
    callsAsTherapist;
    therapist;
    ownedOfficeLocations;
    allowedOfficeLocations;
    fileUploads;
    office;
    currentOfficeLocation;
    userSettings;
    patientStatus;
    userDiagnosis;
    exercisePrograms;
    isOnboarded;
    index;
    notificationsAsRecipient;
    notificationsAsActor;
    patients;
    notificationsAsNewTherapist;
    agreedNewsletter;
    lastVersion;
    uploadedExercises;
    sharedExercises;
    appFeedbacks;
    exerciseFavourites;
    consentDeclaration;
    preventionCourseApprovals;
    patientvideoConsentDeclarations;
    reviewedTrainingSessions;
    payments;
    invoices;
    preventionSectionTrackings;
    preventionModuleTrackings;
    anamneses;
    trainingSessions;
    userIcd10;
    activityPointTrackings;
    activityPointSummary;
    trainingSessionStats;
    reminderUsers;
    customForms;
    officeProductAssignments;
    hubspotQuestionAnswers;
    featureRankings;
    userStats;
    connectedStripeCustomers;
    apikeys;
    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
    get allowedOfficeLocationIds() {
        return this.allowedOfficeLocations.map((location) => location.id);
    }
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], UserFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsOptional(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "keycloakId", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], UserFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], UserFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "deletedAt", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "officeId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "currentOfficeLocationId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "email", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "contactEmail", void 0);
__decorate([
    IsOptional(),
    Expose(),
    Type(() => AddressFieldDto),
    __metadata("design:type", AddressFieldDto)
], UserFullSizeDto.prototype, "addressField", void 0);
__decorate([
    IsOptional(),
    Expose(),
    Type(() => ConsentDeclarerDto),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "consentDeclaredBy", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "lastName", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "birthdate", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "mobilePhone", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "profileImage", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "notes", void 0);
__decorate([
    IsDateString(),
    Expose({
        groups: [Role.SUPERADMIN, Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT],
    }),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "registeredAt", void 0);
__decorate([
    IsEnum(AccessStatus),
    Expose(),
    __metadata("design:type", String)
], UserFullSizeDto.prototype, "accessStatus", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "street", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    MinLength(4),
    MaxLength(5),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "zip", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "town", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "industry", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "website", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "krankenkasse", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "pkvInsurerName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "pkvPolicyNumber", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "salutation", void 0);
__decorate([
    IsEnum(Role),
    Expose(),
    __metadata("design:type", String)
], UserFullSizeDto.prototype, "role", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "therapyArea", void 0);
__decorate([
    IsOptional(),
    Expose(),
    IsUUID(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "therapistId", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], UserFullSizeDto.prototype, "agreedTermsConditions", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "dateAgreedTermsConditions", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "agreedTermsConditionsType", void 0);
__decorate([
    IsBoolean(),
    Expose({
        groups: [Role.SUPERADMIN, Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT],
    }),
    __metadata("design:type", Boolean)
], UserFullSizeDto.prototype, "isArchived", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "countryCode", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], UserFullSizeDto.prototype, "agreedConsentfile", void 0);
__decorate([
    Type(() => CustomFormAnswerFullSizeDto),
    IsArray(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "customFormAnswers", void 0);
__decorate([
    Type(() => CallPatientFullSizeDto),
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "callsAsPatient", void 0);
__decorate([
    Type(() => CallFullSizeDto),
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "callsAsTherapist", void 0);
__decorate([
    IsObject(),
    Type(() => UserFullSizeDto),
    Exclude(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "therapist", void 0);
__decorate([
    IsArray(),
    Type(() => OfficeLocationFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "ownedOfficeLocations", void 0);
__decorate([
    IsArray(),
    Type(() => OfficeLocationStub),
    Expose({
        groups: [Role.SUPERADMIN, Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT],
    }),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "allowedOfficeLocations", void 0);
__decorate([
    IsArray(),
    Type(() => FileUploadFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "fileUploads", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeFullSizeDto),
    Exclude(),
    __metadata("design:type", OfficeFullSizeDto)
], UserFullSizeDto.prototype, "office", void 0);
__decorate([
    IsObject(),
    Type(() => OfficeLocationFullSizeDto),
    Exclude(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "currentOfficeLocation", void 0);
__decorate([
    IsObject(),
    Type(() => UserSettingsFullSizeDto),
    Exclude(),
    __metadata("design:type", UserSettingsFullSizeDto)
], UserFullSizeDto.prototype, "userSettings", void 0);
__decorate([
    IsObject(),
    Type(() => PatientStatusDto),
    Exclude(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "patientStatus", void 0);
__decorate([
    IsObject(),
    Type(() => UserDiagnosisFullSizeDto),
    Exclude(),
    __metadata("design:type", UserDiagnosisFullSizeDto)
], UserFullSizeDto.prototype, "userDiagnosis", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseProgramFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "exercisePrograms", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UserFullSizeDto.prototype, "isOnboarded", void 0);
__decorate([
    IsNumber(),
    Exclude(),
    __metadata("design:type", Number)
], UserFullSizeDto.prototype, "index", void 0);
__decorate([
    IsArray(),
    Type(() => NotificationFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "notificationsAsRecipient", void 0);
__decorate([
    IsArray(),
    Type(() => NotificationFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "notificationsAsActor", void 0);
__decorate([
    IsArray(),
    Type(() => UserFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "patients", void 0);
__decorate([
    IsArray(),
    Type(() => NotificationFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "notificationsAsNewTherapist", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Boolean)
], UserFullSizeDto.prototype, "agreedNewsletter", void 0);
__decorate([
    IsSemVer(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], UserFullSizeDto.prototype, "lastVersion", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "uploadedExercises", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "sharedExercises", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "appFeedbacks", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseFavouriteFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "exerciseFavourites", void 0);
__decorate([
    IsObject(),
    Type(() => ConsentDeclarationFullSizeDto),
    Exclude(),
    __metadata("design:type", ConsentDeclarationFullSizeDto)
], UserFullSizeDto.prototype, "consentDeclaration", void 0);
__decorate([
    IsArray(),
    Type(() => PreventionCourseApprovalFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "preventionCourseApprovals", void 0);
__decorate([
    IsArray(),
    Type(() => PatientvideoConsentDeclarationFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "patientvideoConsentDeclarations", void 0);
__decorate([
    IsArray(),
    Type(() => TrainingSessionFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "reviewedTrainingSessions", void 0);
__decorate([
    Type(() => PaymentFullSizeDto),
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "payments", void 0);
__decorate([
    Type(() => InvoiceFullSizeDto),
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "invoices", void 0);
__decorate([
    Type(() => PreventionSectionTrackingFullSizeDto),
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "preventionSectionTrackings", void 0);
__decorate([
    Type(() => PreventionModuleTrackingFullSizeDto),
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "preventionModuleTrackings", void 0);
__decorate([
    IsArray(),
    Type(() => AnamnesisFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "anamneses", void 0);
__decorate([
    IsArray(),
    Type(() => TrainingSessionFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "trainingSessions", void 0);
__decorate([
    IsObject(),
    Type(() => UserIcd10FullSizeDto),
    Expose(),
    __metadata("design:type", UserIcd10FullSizeDto)
], UserFullSizeDto.prototype, "userIcd10", void 0);
__decorate([
    IsArray(),
    Type(() => ActivityPointTrackingFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "activityPointTrackings", void 0);
__decorate([
    IsObject(),
    Type(() => ActivityPointSummaryFullSizeDto),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", ActivityPointSummaryFullSizeDto)
], UserFullSizeDto.prototype, "activityPointSummary", void 0);
__decorate([
    IsObject(),
    Type(() => UserTrainingSessionStatsFullSizeDto),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", UserTrainingSessionStatsFullSizeDto)
], UserFullSizeDto.prototype, "trainingSessionStats", void 0);
__decorate([
    IsArray(),
    Type(() => ReminderUserFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "reminderUsers", void 0);
__decorate([
    IsArray(),
    Type(() => CustomFormFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "customForms", void 0);
__decorate([
    IsArray(),
    Type(() => OfficeProductAssignmentFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "officeProductAssignments", void 0);
__decorate([
    Type(() => HubSpotQuestionAnswerFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "hubspotQuestionAnswers", void 0);
__decorate([
    Type(() => FeatureRankingFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "featureRankings", void 0);
__decorate([
    IsObject(),
    Type(() => UserStatsFullSizeDto),
    Exclude(),
    __metadata("design:type", UserStatsFullSizeDto)
], UserFullSizeDto.prototype, "userStats", void 0);
__decorate([
    IsArray(),
    Type(() => ConnectedStripeCustomerPatientFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "connectedStripeCustomers", void 0);
__decorate([
    IsArray(),
    Type(() => ApiKeyFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], UserFullSizeDto.prototype, "apikeys", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], UserFullSizeDto.prototype, "fullName", null);
__decorate([
    IsArray(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], UserFullSizeDto.prototype, "allowedOfficeLocationIds", null);
//# sourceMappingURL=user.full-size.dto.js.map